
var api;
var listname;

function load_getresponse(user_id) {
    $.ajax({
        url: '/get_response/gr_get_account/' + user_id,
        dataType: 'json',
        success: function (data) {
            if (data.length === 0) {
                window.alert('You do not have Get Response defaults');
            } else {
                document.getElementById('ar_api_key').value = data['gr_api_key'];
                api = data['gr_api_key'];
                listname = data['gr_login_id'];
                $.ajax({
                    url: '/get_response/get_campaign_select2/' + api,
                    dataType: 'text',
                    success: function (data) {
                        var newOptions = data;
                        document.getElementById('ar_list_name').innerHTML = newOptions;
                        $('#ar_list_name').val(listname);
                    },
                    error: window.JVZoo.Ajax.StandardErrorHandler
                });
            }
        },
        error: function(xhr, status, error){
            alert('There was an issue retrieving your defaults');
            // window.JVZoo.Ajax.StandardErrorHandler
        },
    });

    $('#ar_api_key').change(function() {
        $('#ar_list_name').empty();
    });
}


